import { FileType, } from '@office-start/document-types';
import React from 'react';
var brandIconUrl = 'https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/svg/';
export var getBrandName = function (fileType) {
    switch (fileType) {
        case FileType.Word:
            return 'word';
        case FileType.Excel:
            return 'excel';
        case FileType.Visio:
            return 'visio';
        case FileType.PowerPoint:
            return 'powerpoint';
        case FileType.OneNote:
            return 'onenote';
    }
    return undefined;
};
export var getBrandIcon = function (props) {
    var brandName = getBrandName(props.fileType);
    if (!brandName) {
        return undefined;
    }
    var iconUrl = "".concat(brandIconUrl).concat(brandName, "_").concat(props.size, "x1.svg");
    return (React.createElement("img", { src: iconUrl, width: props.size, height: props.size, alt: "".concat(brandName, " icon"), className: props.className, "aria-hidden": "true" }));
};
//# sourceMappingURL=ActionContextBrandIcons.js.map